export default "__VITE_ASSET__Px0egzaQ__"